<template>
  <div class="form-wrap" :data-testid="dataTestid">
    <div class="static-info__name">{{ name }}</div>
    <div class="static-info__value" :class="valueClass">{{ value || '–' }}</div>
  </div>
</template>

<script>
export default {
  name: 'StaticInfo',
  props: {
    name: { type: String, required: true },
    value: { type: [Number, String], required: false },
    dataTestid: { type: String, required: false },
    valueClass: { type: Array, required: false },
  },
}
</script>

<style lang="scss">
.static-info {
  &__name {
    display: block;
    font-size: 16px;
    margin-bottom: 8px;
    font-weight: 600;
    color: #91979f;
  }

  &__value {
    display: block;
    width: 100%;
    padding: 14px;
    line-height: 1.5;
    background: #efefef;
    font-size: 16px;
    font-weight: bold;
    border-radius: var(--vs-border-radius);
  }
}
</style>
